import { LogoPropsType } from './logoTypes';

export default function NetflixLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg
      viewBox="0 0 190 50"
      fill="currentColor"
      role="img"
      aria-labelledby="logo-title"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title id="logo-title">Netflix Logo</title>
      <desc>
        The Netflix logo features a bold, stylized letter &quot;N&quot; in red, representing the company&apos;s focus on
        entertainment and streaming services. The design is simple yet iconic, making it easily recognizable.
      </desc>
      <g id="COMPANY-LOGO">
        <path
          id="LOGO-NETFLIX"
          d="M26.817 46.7771C23.9874 47.2658 21.1082 47.4124 18.1297 47.8026L9.04493 21.631V48.9258C6.21542 49.2187 3.63406 49.6094 0.953339 50V0H8.49919L18.8246 28.3696V0H26.817V46.7771ZM42.4544 18.3106C45.5325 18.3106 50.2485 18.164 53.0779 18.164V25.9764C49.5532 25.9764 45.4331 25.9764 42.4544 26.1229V37.7442C47.121 37.4513 51.7873 37.0603 56.5032 36.9137V44.4329L34.5115 46.1422V0H56.5032V7.81251H42.4544V18.3106ZM86.0403 7.81269H77.7998V43.7501C75.119 43.7501 72.4384 43.7501 69.8574 43.8475V7.81269H61.6169V0H86.0407L86.0403 7.81269ZM98.9473 17.7736H109.819V25.586H98.9473V43.3107H91.1529V0H113.344V7.81251H98.9473V17.7736ZM126.251 36.4746C130.768 36.5719 135.335 36.9143 139.753 37.1581V44.8731C132.655 44.4333 125.556 43.9944 118.308 43.8475V0H126.251V36.4746ZM146.455 45.4101C148.987 45.5568 151.668 45.7033 154.25 45.996V0H146.455V45.4101ZM189.049 0L178.971 23.7793L189.049 50C186.07 49.6094 183.091 49.0722 180.113 48.5839L174.404 34.1311L168.597 47.4124C165.716 46.9236 162.937 46.7771 160.058 46.3865L170.284 23.4861L161.05 0H169.588L174.801 13.1348L180.361 0H189.049Z"
          fill={monochrome ? 'currentColor' : '#E50914'}
        />
      </g>
    </svg>
  );
}
